import { ExpandMoreOutlined } from '@mui/icons-material'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  styled,
  useTheme,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import CSVIcon from '../../assets/icons/csv-icon.svg'
import XLSXIcon from '../../assets/icons/xlsx-icon.svg'
import Project from '../../types/Project'
import { useGetProjectsAll } from '../projects/hooks'
// @ts-ignore
import { useAuth0 } from '@auth0/auth0-react'
import Excel from 'exceljs'
import moment from 'moment-timezone'
import { SnackbarComponent } from '../../components/Snackbar'
import Api from '../../lib/api'
import amazonService from '../../lib/aws'
import { formatDateMMDDYYYY, toHourTime, toHourTimeAlt } from '../../lib/time'

// import ReactExport from "react-export-excel";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { CalendarIcon } from '../../assets/icons/icons'
import * as Sentry from '@sentry/react'
import { useGetQuestions } from '../Adminquestion/HrQuestionhook'

const StyledPdfBox = styled(Box)(({ theme }) => ({
  height: '80px',
  width: '80px',
  margin: '0 auto',
  marginBottom: 15,
}))

const commonFont = {
  fontFamily: 'Buenos Aires',
}

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const sampleData = [
  {
    firstName: 'John',
    lastName: 'Doe',
    gustoEmployee: 'Yes',
    gustoEmployeeID: '12345',
    regularHours: 40,
    overtimeHours: 5,
  },
  {
    firstName: 'Jane',
    lastName: 'Smith',
    gustoEmployee: 'No',
    gustoEmployeeID: '67890',
    regularHours: 38,
    overtimeHours: 7,
  },
]

const pdfArr = [
  {
    name: 'Summit Builders Co. 29th Jan. 2024',
    size: '230kb',
  },
  {
    name: 'TerraCraft Construction Solutions Annual Report',
    size: '230kb',
  },
  {
    name: 'Report Precision Structures Inc. 02.04.23',
    size: '230kb',
  },
]
const pdfArr2 = [
  {
    name: 'Summit Builders Co. 29th Jan. 2024',
    size: '230kb',
  },
  {
    name: 'TerraCraft Construction Solutions Annual Report',
    size: '230kb',
  },
  {
    name: 'Report Precision Structures Inc. 02.04.23',
    size: '230kb',
  },
  {
    name: 'Last Month - Urban Horizon Builders 20.1',
    size: '230kb',
  },
]

const radioLabels = [
  'This Week',
  'Last Week',
  'Last Month',
  'This Year',
  'All Time',
  'Custom Date Range',
]

export const ReportHome = () => {
  const theme = useTheme()
  const { data: projects, isFetching: isFetchingProjects } =
    useGetProjectsAll('projects')
  const [startTimeStamp, setStartTimeStamp] = useState<any>(dayjs())
  const [endTimeStamp, setEndTimeStamp] = useState<any>(dayjs())

  const [params, setParams] = useState('')
  const [selectedType, setSelectedType] = useState('This Week')
  const { getAccessTokenSilently } = useAuth0()
  const [snakbarOptions, setSnakbarOptions] = useState({
    open: false,
    type: '',
    message: '',
  })
  const [loading, setLoading] = useState(false)
  const [accountingSystem, setAccountingSystem] =
    useState<string>('pro-contractor')
  const [project, setProject] = useState<string>()
  const [reports, setReports] = useState([])
  const [selectAllProjects, setSelectAllProjects] = useState(false)
  const { data: hrQuestions, refetch, isLoading } = useGetQuestions('questions')

  const handleChange = (event: any) => {
    setAccountingSystem(event.target.value as string)
  }

  const handleChangeProject = (event: any) => {
    setProject(event.target.value as string)
  }

  const getTimeRange = (selectedType: string) => {
    let startTime, endTime

    endTime = moment().endOf('day').unix()

    switch (selectedType) {
      case 'This Week':
        startTime = moment().startOf('week').unix()
        break
      case 'Last Week':
        startTime = moment().subtract(1, 'weeks').startOf('week').unix()
        endTime = moment().subtract(1, 'weeks').endOf('week').unix()
        break
      case 'Last Month':
        startTime = moment().subtract(1, 'months').startOf('month').unix()
        endTime = moment().subtract(1, 'months').endOf('month').unix()
        break
      case 'This Year':
        startTime = moment().startOf('year').unix()
        break
      case 'All Time':
        startTime = moment(0).unix()
        break
      case 'Custom Date Range':
        startTime = moment(startTimeStamp?.toString()).startOf('day').unix()
        endTime = moment(endTimeStamp?.toString()).endOf('day').unix()
        break
      default:
        startTime = moment().unix()
    }

    return { startTime, endTime }
  }

  const addWorksheetRow = (
    worksheet: any,
    data: any,
    currentCostCodeIndex: number
  ) => {
    const costCodePercentageWorked =
      currentCostCodeIndex === 0 &&
      (!data.costCodes || data.costCodes.length === 0)
        ? 100
        : data.costCodes[currentCostCodeIndex].percentage
    const adjustedRegularHours = (
      ((data?.regularTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)
    const adjustedOvertimeHours = (
      ((data?.overTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)
    const adjustedDoubletimeHours = (
      ((data?.doubleOverTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)

    const RegularHours = data?.regularTimeWorkedInMinutes
      ? adjustedRegularHours
      : data.formattedTimeDurations.endTime
      ? '0'
      : '0'
    const OvertimeHours = data?.overTimeWorkedInMinutes
      ? adjustedOvertimeHours
      : '0'
    const DoubletimeHours = data?.doubleOverTimeWorkedInMinutes
      ? adjustedDoubletimeHours
      : '0'

    worksheet.addRow({
      Company: data?.project?.clientName,
      Employee: data?.user?.idNumber,
      LineNumber: '',
      OverwriteLine: '',
      DateWorked: formatDateMMDDYYYY(data.formattedTimeDurations.startTime),
      TransactionType: 'Project Cost',
      DistributionCompany: '',
      ProfitCenter: data.project.projectNumber,
      AllowPostingToClosedProfitCenter: '',
      CostCode:
        data.costCodes.length === 0
          ? ''
          : data.costCodes![
              currentCostCodeIndex
            ]?.costCodeDetail![0]?.label.split('-')[0],
      CMR: '',
      Division: data.project.division,
      WorkLocation: '',
      TradeUnion: '',
      PayClass: '',
      CostType: 'Labor',
      PaidTimeOff: '',
      AllowPTOBeforeAvailableForUseDate: '',
      AllowPTOOverBalance: '',
      PayrollCostAccount: '',
      InsuranceClassification: '',
      StartTime: toHourTimeAlt(data.formattedTimeDurations.startTime),
      EndTime: data.formattedTimeDurations.endTime
        ? toHourTimeAlt(data.formattedTimeDurations.endTime)
        : 'Open',
      RegularHours,
      RegularRate: '',
      OvertimeHours,
      OvertimeRate: '',
      DoubletimeHours,
      DoubletimeRate: '',
      NumberOfPieces: '',
      Amount: '',
      OvertimeExempt: '',
      Description:
        data.costCodes.length === 0
          ? ''
          : data.costCodes![currentCostCodeIndex]?.description ?? '',
      MeterReading: '',
      ...data?.clockOutAnswers?.reduce((acc: any, b: any) => {
        acc[b?.question] = b?.answerText
        return acc
      }, {}),
      // Injured:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[0]
      //     ? data.clockOutAnswers[0].answer
      //     : '',
      // Water:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[1]
      //     ? data.clockOutAnswers[1].answer
      //     : '',
      // Break:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[2]
      //     ? data.clockOutAnswers[2].answer
      //     : '',
      // Issue:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[4]
      //     ? data.clockOutAnswers[4].answer
      //     : '',
      // LunchBreak:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[3]
      //     ? data.clockOutAnswers[3].answer
      //     : '',
    })
  }

  async function generateExcelFile(employees: any) {
    let workbook = new Excel.Workbook()
    if (accountingSystem !== 'gusto') {
      let worksheet1 = workbook.addWorksheet('General')
      worksheet1.columns = [
        { header: 'Company', key: 'company', width: 10 },
        { header: 'Employee', key: 'employee', width: 10 },
        { header: 'Check Type', key: 'checkType', width: 20 },
        { header: 'Check Number', key: 'checkNumber', width: 15 },
        { header: 'Bonus Tax Percent', key: 'bonusTaxPercent', width: 20 },
      ]

      // Filter out duplicate employees for General tab
      // Workers need to have a user.idNumber
      const employeeIds = new Set()
      const filteredEmployees = employees
        ? employees.filter((employee: any) => {
            if (employeeIds.has(employee.user.idNumber)) {
              return false
            } else {
              employeeIds.add(employee.user.idNumber)
              return true
            }
          })
        : []

      filteredEmployees.forEach((item: any) => {
        worksheet1.addRow({
          company: item?.project.clientName,
          employee: item?.user.idNumber,
          checkType: 'Computer Printed',
          checkNumber: '',
          bonusTaxPercent: '25%',
        })
      })
    }
    let worksheet = workbook.addWorksheet(
      accountingSystem === 'gusto' ? 'My Sheet' : 'Distribution'
    )

    if (accountingSystem === 'gusto') {
      worksheet.columns = [
        { header: 'First Name', key: 'firstName', width: 10 },
        { header: 'Last Name', key: 'lastName', width: 10 },
        { header: 'Gusto Employee ID', key: 'gustoEmployeeID', width: 20 },
        { header: 'Regular Hours', key: 'regularHours', width: 10 },
        { header: 'Overtime Hours', key: 'overtimeHours', width: 15 },
      ]
      employees?.forEach((item: any) => {
        worksheet.addRow({
          firstName: item?.user?.firstName,
          lastName: item?.user?.lastName,
          gustoEmployeeID: item?.user?.idNumber,
          regularHours: item?.formattedTimeDurations?.regularTimeWorked,
          overtimeHours: item?.formattedTimeDurations?.overTimeWorked,
        })
      })
    } else {
      worksheet.columns = [
        { header: 'Company', key: 'Company', width: 20 },
        { header: 'Employee', key: 'Employee', width: 20 },
        { header: 'Line Number', key: 'LineNumber', width: 15 },
        { header: 'Overwrite Line', key: 'OverwriteLine', width: 20 },
        { header: 'Date Worked', key: 'DateWorked', width: 20 },
        { header: 'Transaction Type', key: 'TransactionType', width: 20 },
        {
          header: 'Distribution Company',
          key: 'DistributionCompany',
          width: 25,
        },
        { header: 'Profit Center', key: 'ProfitCenter', width: 20 },
        {
          header: 'Allow Posting to Closed Profit Center',
          key: 'AllowPostingToClosedProfitCenter',
          width: 35,
        },
        { header: 'Cost Code', key: 'CostCode', width: 15 },
        { header: 'CMR', key: 'CMR', width: 10 },
        { header: 'Division', key: 'Division', width: 20 },
        { header: 'Work Location', key: 'WorkLocation', width: 20 },
        { header: 'Trade Union', key: 'TradeUnion', width: 20 },
        { header: 'Pay Class', key: 'PayClass', width: 15 },
        { header: 'Cost Type', key: 'CostType', width: 15 },
        { header: 'Paid Time Off', key: 'PaidTimeOff', width: 15 },
        {
          header: 'Allow PTO Before Available for Use Date',
          key: 'AllowPTOBeforeAvailableForUseDate',
          width: 40,
        },
        {
          header: 'Allow PTO over Balance',
          key: 'AllowPTOOverBalance',
          width: 25,
        },
        {
          header: 'Payroll Cost Account',
          key: 'PayrollCostAccount',
          width: 25,
        },
        {
          header: 'Insurance Classification',
          key: 'InsuranceClassification',
          width: 25,
        },
        { header: 'Start Time', key: 'StartTime', width: 15 },
        { header: 'End Time', key: 'EndTime', width: 15 },
        { header: 'Regular Hours', key: 'RegularHours', width: 15 },
        { header: 'Regular Rate', key: 'RegularRate', width: 15 },
        { header: 'Overtime Hours', key: 'OvertimeHours', width: 15 },
        { header: 'Overtime Rate', key: 'OvertimeRate', width: 15 },
        { header: 'Doubletime Hours', key: 'DoubletimeHours', width: 20 },
        { header: 'Doubletime Rate', key: 'DoubletimeRate', width: 20 },
        { header: 'Number Of Pieces', key: 'NumberOfPieces', width: 20 },
        { header: 'Amount', key: 'Amount', width: 15 },
        { header: 'Overtime Exempt', key: 'OvertimeExempt', width: 20 },
        { header: 'Description', key: 'Description', width: 25 },
        { header: 'Meter Reading', key: 'MeterReading', width: 20 },
        ...hrQuestions?.map((item: any) => {
          return {
            header: item?.questions[0]?.questionText,
            key: item?.questions[0]?.questionText,
            width: item?.questions[0]?.questionText?.length * 1.5,
          }
        }),
        // { header: 'Injured', key: 'Injured', width: 15 },
        // { header: 'Water', key: 'Water', width: 15 },
        // { header: 'Break', key: 'Break', width: 15 },
        // { header: 'Issue', key: 'Issue', width: 15 },
        // { header: 'Lunch Break', key: 'LunchBreak', width: 20 },
      ]

      try {
        employees?.forEach((data: any) => {
          let currentCostCodeIndex = 0
          // Add worksheet row
          addWorksheetRow(worksheet, data, currentCostCodeIndex)
          currentCostCodeIndex = 1
          while (data.costCodes.length > currentCostCodeIndex) {
            addWorksheetRow(worksheet, data, currentCostCodeIndex)
            currentCostCodeIndex++
          }
        })
      } catch (err) {
        console.log('Report Home error exporting accounting report:', err)
        Sentry.captureException(err)
      }
    }

    // Convert workbook to a Blob
    const buffer = await (accountingSystem === 'gusto'
      ? workbook.csv.writeBuffer()
      : workbook.xlsx.writeBuffer())
    const blob = new Blob([buffer], {
      type:
        accountingSystem === 'gusto'
          ? 'text/csv'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    return blob
  }

  const uploadFileToS3 = async (file: any) => {
    if (file) {
      const fileName = uuidv4()
      const s3FileUrl = await amazonService().uploadExcelFile(
        file,
        `${fileName}.${accountingSystem === 'gusto' ? 'csv' : 'xlsx'}`
      )
      return s3FileUrl
    }
  }

  function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  const handleUploadClick = async () => {
    setLoading(true)

    try {
      const projectsSTR = selectAllProjects
        ? projects
            .map((item: any) => item.id.toString())
            .join(',')
            .toString()
        : (project ?? '').toString()
      var paramStr = ''
      if (project) {
        paramStr += 'project=' + projectsSTR + '&'
      }

      paramStr += `timezone=${moment.tz.guess()}&limit=9999999&`
      const { startTime, endTime } = getTimeRange(selectedType)
      paramStr += `startTimeStamp=${moment
        .unix(startTime)
        .toDate()
        .toISOString()}&endTimeStamp=${moment
        .unix(endTime)
        .toDate()
        .toISOString()}&`
      const token = await getAccessTokenSilently()
      const employees = await Api.get(`v1/timecards?${paramStr}`, token)

      if (project == null && selectAllProjects === false) {
        setSnakbarOptions({
          open: true,
          message: 'No project has been selected!',
          type: 'error',
        })
        setTimeout(() => {
          setSnakbarOptions({
            open: false,
            message: '',
            type: '',
          })
        }, 3000)
        return
      }
      if (accountingSystem !== '') {
        try {
          if ((employees?.data?.length ?? 0) > 0) {
            const excelBlob = await generateExcelFile(employees?.data)
            const fileName = `${accountingSystem} Report ${moment().format(
              'DD.MM.YY'
            )}`
            const file = new File([excelBlob], fileName, {
              type:
                accountingSystem === 'gusto'
                  ? 'text/csv'
                  : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            const fileURL = await uploadFileToS3(file)

            const token = await getAccessTokenSilently()
            const reportRes = await Api.post(
              `v1/reports`,
              {
                name: `${accountingSystem} Report ${moment().format(
                  'DD.MM.YY'
                )}`,
                description: '',
                fileSize: formatBytes(excelBlob.size),
                type: accountingSystem,
                timelineType: selectedType,
                isSelectedAllProjects: selectAllProjects,
                startDate: moment.unix(startTime).toDate(),
                endDate: moment.unix(endTime).toDate(),
                fileUrl: fileURL,
                projects: projectsSTR.split(','),
              },
              token
            )
            getReports()
            var _fileURL = URL.createObjectURL(file)

            var downloadLink: any = document.createElement('a')
            downloadLink.href = _fileURL
            downloadLink.download = `${fileName}.${
              accountingSystem === 'gusto' ? 'csv' : 'xlsx'
            }`
            document.body.appendChild(downloadLink)
            downloadLink.click() // Programmatically click the link to trigger the download
            setSnakbarOptions({
              open: true,
              message: 'Report has been generated & downloaded successfully!',
              type: 'success',
            })
            setTimeout(() => {
              setSnakbarOptions({
                open: false,
                message: '',
                type: '',
              })
            }, 3000)

            // Clean up by revoking the Blob URL and removing the link
            URL.revokeObjectURL(downloadLink.href)
            document.body.removeChild(downloadLink)
          } else {
            setSnakbarOptions({
              open: true,
              message: 'There are no timecards to export!',
              type: 'error',
            })
            setTimeout(() => {
              setSnakbarOptions({
                open: false,
                message: '',
                type: '',
              })
            }, 3000)
          }
        } catch (error) {
          console.error('Error generating or uploading the file:', error)
        }
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getReports()
  }, [])

  const getReports = async () => {
    const token = await getAccessTokenSilently()
    const reports = await Api.get(`v1/reports`, token)
    if (reports) {
      setReports(reports)
    }
  }

  return (
    <>
      <SnackbarComponent
        severity={snakbarOptions.type}
        message={snakbarOptions.message}
        open={snakbarOptions.open}
        onClose={() => {
          setSnakbarOptions(prev => ({
            ...prev,
            open: false,
          }))
        }}
      />

      <Box sx={{ marginLeft: 2, marginRight: 2, marginBottom: 0 }}>
        <Grid
          container
          spacing={3}
          alignItems='start'
          sx={{
            mb: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
          }}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              '& .MuiCard-root': {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              },
            }}>
            <Card
              sx={{
                padding: 1,
                boxShadow: 'none',
                border: '1px solid #EEEEEE',
                borderRadius: '8px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}>
              <CardHeader
                titleTypographyProps={{
                  sx: {
                    fontWeight: 600,
                    fontSize: '1.5rem',
                    lineHeight: '1.334',
                    display: 'block',
                    fontFamily: 'Rza',
                  },
                }}
                title='Most Recent Reports'
              />
              <CardContent>
                <Grid
                  container
                  spacing={2}
                  sx={{ display: 'flex', flexWrap: 'wrap' }}>
                  {reports.slice(0, 3).map((pdf: any, i) => {
                    return (
                      <Grid
                        key={i}
                        item
                        xs={4}
                        sx={{
                          height: '100%',
                          cursor: 'pointer',
                          flexGrow: 1,
                          flexBasis: '33.33%',
                          minHeight: '200px',
                        }}
                        onClick={() => {
                          fetch(pdf?.fileUrl).then(function (t) {
                            return t.blob().then(b => {
                              var a = document.createElement('a')
                              a.href = URL.createObjectURL(b)
                              a.setAttribute(
                                'download',
                                pdf.name +
                                  '.' +
                                  `${pdf.type === 'gusto' ? 'csv' : 'xlsx'}`
                              )
                              a.click()
                            })
                          })
                        }}>
                        <Box
                          sx={{
                            border: '1px solid #EEEEEE',
                            borderRadius: '4px',
                            padding: 2,
                            backgroundColor: '#F1EFF54D',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                          }}>
                          <StyledPdfBox style={{ flex: '1 1 auto' }}>
                            <img
                              src={pdf.type === 'gusto' ? CSVIcon : XLSXIcon}
                              style={{
                                height: '100%',
                                width: '100%',
                                color: '#F0845D',
                              }}
                              alt={
                                pdf.type === 'gusto' ? 'CSV icon' : 'XLSX icon'
                              }
                            />
                          </StyledPdfBox>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              sx={{
                                fontSize: 13,
                                fontWeight: 500,
                                color: '#5A525B',
                                maxLines: 2,
                                lineHeight: '16px',
                                fontFamily: 'Buenos Aires',
                              }}>
                              {pdf.name}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: 11,
                                color: '#98909B',
                                fontFamily: 'Buenos Aires',
                              }}>
                              {pdf.fileSize}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    )
                  })}
                </Grid>
              </CardContent>
              <CardActions
                sx={{ margin: '0 8px', marginBottom: 1, marginTop: 2.5 }}>
                <Button
                  variant='outlined'
                  sx={{
                    fontFamily: 'Circular Std',
                    color: '#F0845D',
                    borderColor: '#F0845D',
                    fontSize: '12px',
                    textTransform: 'none',
                    py: 1.5,
                    width: '100%',
                    ':hover': {
                      borderColor: '#F0845D',
                    },
                  }}>
                  Report Builder
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              '& .MuiCard-root': {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              },
            }}>
            <Card
              sx={{
                padding: 1,
                boxShadow: 'none',
                border: '1px solid #EEEEEE',
                borderRadius: '8px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}>
              <CardHeader
                title='Payroll Export'
                titleTypographyProps={{
                  sx: { fontFamily: 'Rza', fontWeight: 600 },
                }}
              />
              <CardContent sx={{ marginBOttom: 0 }}>
                <FormControl
                  sx={{
                    width: '100%',
                    fontSize: '13px',
                    color: '#ACB9B5',
                  }}>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      // padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Select
                      displayEmpty // This prop makes the first empty `MenuItem` visible as a placeholder
                      id='demo-simple-select'
                      value={accountingSystem}
                      onChange={handleChange}
                      IconComponent={ExpandMoreOutlined}
                      sx={{
                        width: '100%',
                        border: 'none',
                        boxShadow: 'none',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                        '& .MuiSelect-select': {
                          padding: theme.spacing(0.8, 0, 0.8, 0),
                        },
                        '&:hover, & fieldset, & fieldset:hover': {
                          border: 'none',
                          // padding: 0,
                          margin: 0,
                          boxShadow: 'none',
                        },
                      }}>
                      <MenuItem sx={{ fontFamily: 'Rza' }} value='gusto'>
                        Gusto
                      </MenuItem>
                      <MenuItem
                        sx={{ fontFamily: 'Rza' }}
                        value='pro-contractor'>
                        Pro Contractor
                      </MenuItem>
                    </Select>
                  </Box>
                </FormControl>

                <Box sx={{ marginBottom: 1, marginTop: 1 }}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby='demo-row-radio-buttons-group-label'
                      name='row-radio-buttons-group'
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 20,
                          color: '#F0845D',
                        },
                        '& .MuiTypography-root': {
                          fontSize: 14,
                          fontWeight: 500,
                          color: '#5A525B',
                          fontFamily: 'Buenos Aires',
                        },
                      }}>
                      {radioLabels.map((label, i) => (
                        <FormControlLabel
                          key={i}
                          value={label}
                          checked={label === selectedType}
                          onChange={(e: any) => setSelectedType(e.target.value)}
                          control={<Radio />}
                          label={label}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Box>

                {selectedType === 'Custom Date Range' && (
                  <>
                    <Typography
                      fontSize={'14px'}
                      color='#5A525B'
                      paddingBottom={0.5}>
                      Select a pay period
                    </Typography>
                    <Grid
                      container
                      spacing={2}
                      alignItems='start'
                      sx={{ mb: 2 }}>
                      <Grid item sm={6}>
                        <Box
                          sx={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            border: '1px solid #DBDBDB',
                            padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                          }}
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'center'}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={startTimeStamp}
                              onChange={(newValue: Date | null) => {
                                setStartTimeStamp(newValue)

                                if (
                                  +moment(endTimeStamp?.toString()).format(
                                    'YYYYMMDD'
                                  ) <
                                  +moment(newValue?.toString()).format(
                                    'YYYYMMDD'
                                  )
                                ) {
                                  setEndTimeStamp(newValue)
                                }
                              }}
                              renderInput={(params: any) => {
                                return (
                                  <TextField
                                    {...params}
                                    variant='standard'
                                    label=''
                                    required
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        // @ts-ignore
                                        <IconButton
                                          {...params.InputProps}
                                          onClick={event => {
                                            // @ts-ignore
                                            params.InputProps.endAdornment.props.children.props.onClick()
                                          }}>
                                          <CalendarIcon />
                                        </IconButton>
                                      ),
                                    }}
                                    sx={{
                                      width: '100%',
                                      '& .MuiInput-underline:before': {
                                        display: 'none',
                                      },
                                      '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                        {
                                          display: 'none',
                                        },
                                      '& .MuiInput-underline:after': {
                                        display: 'none',
                                      },
                                    }}
                                  />
                                )
                              }}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>

                      <Grid item sm={6}>
                        <Box
                          sx={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            border: '1px solid #DBDBDB',
                            padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                          }}
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'center'}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={endTimeStamp}
                              onChange={(newValue: Date | null) => {
                                setEndTimeStamp(newValue)
                              }}
                              minDate={startTimeStamp ?? new Date()}
                              renderInput={(params: any) => {
                                return (
                                  <TextField
                                    {...params}
                                    variant='standard'
                                    label=''
                                    required
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        // @ts-ignore
                                        <IconButton
                                          {...params.InputProps}
                                          onClick={event => {
                                            // @ts-ignore
                                            params.InputProps.endAdornment.props.children.props.onClick()
                                          }}>
                                          <CalendarIcon />
                                        </IconButton>
                                      ),
                                    }}
                                    sx={{
                                      width: '100%',
                                      '& .MuiInput-underline:before': {
                                        display: 'none',
                                      },
                                      '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                        {
                                          display: 'none',
                                        },
                                      '& .MuiInput-underline:after': {
                                        display: 'none',
                                      },
                                    }}
                                  />
                                )
                              }}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                    </Grid>
                  </>
                )}

                <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #DBDBDB',
                  }}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}>
                  <Select
                    displayEmpty // This prop makes the first empty `MenuItem` visible as a placeholder
                    id='demo-simple-select'
                    value={project}
                    onChange={handleChangeProject}
                    IconComponent={ExpandMoreOutlined}
                    sx={{
                      width: '100%',
                      border: 'none',
                      boxShadow: 'none',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      '& .MuiSelect-select': {
                        padding: theme.spacing(0.8, 0, 0.8, 0),
                      },
                      '&:hover, & fieldset, & fieldset:hover': {
                        border: 'none',
                        // padding: 0,
                        margin: 0,
                        boxShadow: 'none',
                      },
                    }}>
                    <MenuItem>Select Project</MenuItem>
                    {projects?.map((item: Project) => {
                      return (
                        <MenuItem
                          value={item.id.toString()}
                          sx={{ fontFamily: 'Buenos Aires' }}>
                          {item.projectName}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </Box>

                <FormGroup sx={{ marginTop: 1.5 }}>
                  <FormControlLabel
                    sx={{
                      '& .Mui-checked': {
                        fontSize: 20,
                        color: '#F0845D !important',
                      },
                      '& .MuiTypography-root': {
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#5A525B',
                        fontFamily: 'Buenos Aires',
                      },
                    }}
                    control={
                      <Checkbox
                        checked={selectAllProjects}
                        onChange={e => setSelectAllProjects(e.target.checked)}
                      />
                    }
                    label='Select All Projects'
                  />
                </FormGroup>
              </CardContent>

              <CardActions
                sx={{ margin: '0 8px', marginBottom: 1, marginTop: 0 }}>
                <Button
                  variant='contained'
                  sx={{
                    fontFamily: 'Circular Std',
                    color: '#FFF',
                    background: '#F0845D',
                    fontSize: '12px',
                    textTransform: 'none',
                    py: 1.5,
                    width: '100%',
                    boxShadow: 'none',
                    ':hover': {
                      background: '#F0845D',
                      boxShadow: 'none',
                    },
                  }}
                  onClick={() => handleUploadClick()}>
                  {loading ? (
                    <CircularProgress
                      sx={{ color: 'white', width: 20, height: 20 }}
                      size={22}
                    />
                  ) : (
                    'Generate Report'
                  )}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
        {/* <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              "& .MuiCard-root": {
                height: "100%",
              },
            }}
          >
            <Card
              sx={{
                padding: 1,
                boxShadow: "none",
                border: "1px solid #EEEEEE",
                borderRadius: "8px",
              }}
            >
              <CardHeader title="Favorite Reports" titleTypographyProps={{ sx: { fontFamily: 'Rza',fontWeight: 600, } }}  />
              <CardContent sx={{ paddingBottom: 0, paddingTop: 0 }}>
                <List sx={{ width: "100%", bgcolor: "background.paper" }}>
                  {pdfArr2.map((pdf, i) => {
                    return (
                      <ListItem
                        key={i}
                        secondaryAction={
                          <IconButton edge="end" aria-label="delete">
                            <Grade
                              sx={{ color: "#F0BE5D", fontSize: "20px" }}
                            />
                          </IconButton>
                        }
                        sx={{
                          padding: 0,
                          paddingBottom: 0.5,
                          paddingTop: 1.5,
                          borderBottom: "0.1px solid rgba(90, 82, 91, 0.3)",
                          "& .MuiTypography-body1": {
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#5A525B",
                          },
                          "& .MuiTypography-body2": {
                            fontSize: 10,
                            fontWeight: 500,
                            color: "#98909B",
                          },
                        }}
                      >
                        <ListItemAvatar
                          sx={{
                            width: "36px",
                            minWidth: "36px",
                            marginRight: 1.5,
                          }}
                        >
                          <img
                            src={PDFIcon}
                            style={{
                              height: "100%",
                              width: "100%",
                              color: "#F0845D",
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={pdf.name}
                          secondary={pdf.size}
                          sx={{ mt: 0 }}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card
              sx={{
                padding: 1,
                boxShadow: "none",
                border: "1px solid #EEEEEE",
                borderRadius: "8px",
              }}
            >
              <CardHeader
                sx={{ marginBottom: 0, paddingBottom: 0,fontWeight: 600, }}
                title={
                  <Box
                    sx={{
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      display: "flex",
                    }}
                  >
                    <p className="MuiTypography-root MuiTypography-h5 MuiCardHeader-title css-1w6xtne-MuiTypography-root" style={{ fontFamily: 'Rza' }}>
                      Standard Reports
                    </p>
                    <Box>
                      <IconButton
                        sx={{
                          backgroundColor: "rgba(238, 238, 238, 1)",
                          borderRadius: "8px",
                          padding: "9px",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_12_64)">
                            <path
                              d="M1.41999 8.84813C2.00761 10.2307 3.1204 11.3233 4.51356 11.8854C5.20338 12.1638 5.94127 12.3035 6.6851 12.2967C7.42894 12.2899 8.16414 12.1366 8.84874 11.8456C9.53333 11.5547 10.1539 11.1317 10.6751 10.6009C11.1962 10.0701 11.6077 9.44188 11.886 8.75205C12.1644 8.06223 12.3041 7.32434 12.2973 6.58051C12.2905 5.83667 12.1372 5.10147 11.8462 4.41687C11.2586 3.03427 10.1458 1.94172 8.75266 1.37958C7.3595 0.81744 5.80009 0.831755 4.41749 1.41937C3.03488 2.007 1.94233 3.11979 1.38019 4.51295C0.81805 5.90611 0.832365 7.46552 1.41999 8.84813Z"
                              stroke="#5A525B"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.6381 10.6375L15.0312 15.0312"
                              stroke="#5A525B"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_12_64">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </IconButton>
                      <IconButton
                        sx={{
                          backgroundColor: "rgba(238, 238, 238, 1)",
                          borderRadius: "8px",
                          marginLeft: "7px",
                          padding: "7px 12px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "black",
                            fontWeight: "500",
                            fontFamily: 'Circular Std'
                          }}
                        >
                          View All
                        </Typography>
                      </IconButton>
                    </Box>
                  </Box>
                }
              >
                <p>rgba(238, 238, 238, 1)</p>
              </CardHeader>
              <CardContent sx={{ paddingBottom: 0, paddingTop: 2 }}>
                <List
                  sx={{
                    width: "100%",
                    bgcolor: "background.paper",
                  }}
                >
                  <Grid
                    container
                    rowSpacing={1.5}
                    columnSpacing={2}
                    alignItems={"stretch"}
                  >
                    {pdfArr2.concat(pdfArr2).map((pdf, i) => {
                      return (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          sx={{
                            "& .MuiCard-root": {
                              height: "100%",
                            },
                          }}
                        >
                          <ListItem
                            key={i}
                            sx={{
                              borderBottom: "0.1px solid rgba(90, 82, 91, 0.3)",
                              px: 0,
                              paddingTop: 0,
                              paddingBottom: 1,
                              "& .MuiTypography-body1": {
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#5A525B",
                                fontFamily: 'Buenos Aires'
                              },
                              "& .MuiTypography-body2": {
                                fontSize: 10,
                                fontWeight: 500,
                                color: "#98909B",
                                fontFamily: 'Buenos Aires'
                              },
                            }}
                          >
                            <ListItemAvatar
                              sx={{
                                width: "36px",
                                minWidth: "36px",
                                marginRight: 1.5,
                              }}
                            >
                              <img
                                src={PDFIcon}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  color: "#F0845D",
                                }}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={pdf.name}
                              secondary={pdf.size}
                              sx={{
                                "& span": {
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap !important",
                                  overflow: "hidden",
                                  fontFamily: 'Buenos Aires'
                                },
                              }}
                            />
                          </ListItem>
                        </Grid>
                      );
                    })}
                  </Grid>
                </List>
              </CardContent>
              <CardActions
                sx={{
                  marginBottom: 0,
                  paddingTop: 0,
                  justifyContent: "space-between",
                }}
              >
                <Pagination
                  count={10}
                  hideNextButton
                  hidePrevButton
                  sx={{
                    "& .css-1rm84qh-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
                      fontFamily: 'Buenos Aires'
                    }
                  }}
                />
                <div>
                  <IconButton>
                    <ChevronLeft />
                  </IconButton>
                  <IconButton>
                    <ChevronRight />
                  </IconButton>
                </div>
              </CardActions>
            </Card>
          </Grid>
        </Grid> */}
      </Box>
    </>
  )
}
